import type { Testimonial } from '../lib/testimonials';

const categoryLabel: Record<string, string> = {
  recital: 'Recital',
  performance: 'Performance',
  graduate: 'Graduate success',
  lessons: 'Lessons',
};

export function TestimonialCard({
  item,
  showStory = false,
}: {
  item: Testimonial;
  showStory?: boolean;
}) {
  return (
    <blockquote className="testimonial-card" data-category={item.category}>
      <span className="story-badge">{categoryLabel[item.category] ?? item.category}</span>
      <p className="testimonial-quote">“{item.quote}”</p>
      {showStory && item.story ? <p className="testimonial-story">{item.story}</p> : null}
      <footer>
        <cite className="testimonial-name">{item.name}</cite>
        {item.detail ? <span className="testimonial-detail">{item.detail}</span> : null}
      </footer>
    </blockquote>
  );
}
